class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    // CORRECCIÓN 1: Si no existe el toggle, detenemos la ejecución para evitar el error de la línea 5.
    if (!this.mainDetailsToggle) return;

    // Buscamos el summary con seguridad
    const summary = this.mainDetailsToggle.querySelector('summary');
    
    // Si existe el summary, definimos el contenido, si no, salimos.
    if (summary) {
      this.content = summary.nextElementSibling;
    } else {
      return;
    }

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    // Seguridad extra: si no se definió content, no hacemos nada.
    if (!this.content) return; 

    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    // CORRECCIÓN 2: Verificamos que mainDetailsToggle exista antes de quitar atributos (Error línea 28).
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');
    
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
        summary.setAttribute('aria-expanded', false);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    
    // Verificamos que mainDetailsToggle exista antes de acceder a .open
    if (this.mainDetailsToggle) {
        this.header.preventHide = this.mainDetailsToggle.open;
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
